(function() {
  var STORAGE_KEY = 'olfong_store_choice';
  var stored = localStorage.getItem(STORAGE_KEY);
  if (stored) return;

  var STORES = [
    {
      id: 'akureyri',
      name: 'Akureyri',
      postal: '600',
      initials: 'AK',
      url: 'https://olfong-akureyri.myshopify.com/',
      address: 'Mýravegur/Kaupangur, 600 Akureyri'
    },
    {
      id: 'laugarvatn',
      name: 'Laugarvatn',
      postal: '840',
      initials: 'LA',
      url: 'https://olfong-laugarvatn.myshopify.com/',
      address: 'Lindarskógur 5a, 840 Laugarvatn'
    }
  ];

  var currentStore = 'akureyri';
  if (location.hostname.indexOf('laugarvatn') !== -1) {
    currentStore = 'laugarvatn';
  }

  function buildPopup() {
    var overlay = document.createElement('div');
    overlay.className = 'olfong-popup-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-labelledby', 'olfong-popup-title');
    overlay.setAttribute('aria-modal', 'true');

    var choicesHtml = STORES.map(function(s) {
      return '' +
        '<button type="button" class="olfong-popup__choice ' + (s.id === currentStore ? 'is-current' : '') + '" data-store-id="' + s.id + '" data-store-url="' + s.url + '">' +
          '<span class="olfong-popup__badge">' + s.initials + '</span>' +
          '<span class="olfong-popup__text">' +
            '<span class="olfong-popup__name">' + s.postal + ' ' + s.name + '</span>' +
            '<span class="olfong-popup__address">' + s.address + '</span>' +
          '</span>' +
          '<svg class="olfong-popup__arrow" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
            '<line x1="5" y1="12" x2="19" y2="12"/>' +
            '<polyline points="12 5 19 12 12 19"/>' +
          '</svg>' +
        '</button>';
    }).join('');

    overlay.innerHTML =
      '<div class="olfong-popup">' +
        '<div class="olfong-popup__logo" aria-hidden="true">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">' +
            '<path d="M12 22s-8-7.58-8-13a8 8 0 0 1 16 0c0 5.42-8 13-8 13z"/>' +
            '<circle cx="12" cy="9" r="3"/>' +
          '</svg>' +
        '</div>' +
        '<p class="olfong-popup__eyebrow">Velkomin í Ölföng</p>' +
        '<h2 class="olfong-popup__title" id="olfong-popup-title">Hvar viltu versla?</h2>' +
        '<p class="olfong-popup__subtitle">Veldu verslun til að halda áfram</p>' +
        '<div class="olfong-popup__choices">' + choicesHtml + '</div>' +
        '<p class="olfong-popup__hint">' +
          '<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
            '<polyline points="17 1 21 5 17 9"/>' +
            '<path d="M3 11V9a4 4 0 0 1 4-4h14"/>' +
            '<polyline points="7 23 3 19 7 15"/>' +
            '<path d="M21 13v2a4 4 0 0 1-4 4H3"/>' +
          '</svg>' +
          'Þú getur skipt um verslun hvenær sem er með <span class="olfong-popup__hint-pill">AK</span> hnappinum' +
        '</p>' +
      '</div>';

    return overlay;
  }

  function flyToHeader(overlay, chosen) {
    var popup = overlay.querySelector('.olfong-popup');
    var switcher = document.querySelector('store-switcher .ssw__init');

    if (!switcher) {
      overlay.style.opacity = '0';
      setTimeout(function() {
        overlay.remove();
        if (chosen.id !== currentStore) {
          window.location.href = chosen.url;
        }
      }, 400);
      return;
    }

    var switcherRect = switcher.getBoundingClientRect();
    var popupRect = popup.getBoundingClientRect();

    var translateX = switcherRect.left + switcherRect.width / 2 - popupRect.left - popupRect.width / 2;
    var translateY = switcherRect.top + switcherRect.height / 2 - popupRect.top - popupRect.height / 2;

    var scaleX = switcherRect.width / popupRect.width;
    var scaleY = switcherRect.height / popupRect.height;
    var scale = Math.max(scaleX, scaleY);

    overlay.classList.add('is-flying');
    popup.style.transform = 'translate(' + translateX + 'px, ' + translateY + 'px) scale(' + scale + ')';
    popup.style.opacity = '0';

    setTimeout(function() {
      overlay.remove();
      // No pulse — pill stays still after popup vanishes
      if (chosen.id !== currentStore) {
        window.location.href = chosen.url;
      }
    }, 700);
  }

  function show() {
    var overlay = buildPopup();
    document.body.appendChild(overlay);
    requestAnimationFrame(function() {
      overlay.classList.add('is-visible');
    });

    overlay.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-store-id]');
      if (!btn) return;
      var chosenId = btn.dataset.storeId;
      var chosen = null;
      for (var i = 0; i < STORES.length; i++) {
        if (STORES[i].id === chosenId) { chosen = STORES[i]; break; }
      }
      if (!chosen) return;
      localStorage.setItem(STORAGE_KEY, chosenId);
      flyToHeader(overlay, chosen);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', show);
  } else {
    show();
  }
})();